import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { DataService } from 'app/shared/services/dataService';
import * as _ from 'lodash';
import { MatAccordion } from '@angular/material/expansion';
import { CaseService } from '../../shared/services/caseService';
import { BaseComponent } from 'app/shared/baseClasses/BaseComponent';
import { AppConfig } from 'app/app.config';
import { EventList } from 'app/shared/utility/EventAggregator';
import { DialogRef } from '@angular/cdk/dialog';


@Component({
  selector: 'app-case-details',
  templateUrl: './case-details.component.html',
  styleUrls: ['./case-details.component.css']
})
export class CaseDetailsComponent extends BaseComponent implements OnChanges, OnInit {

  @ViewChild(MatAccordion) accordion: MatAccordion;
  constructor(appConfig: AppConfig, public dataService: DataService, private caseService:CaseService) { 
    super(appConfig);
  }
  @Input() caseDetails;
  template;
  ignoreFields = [' Family Interview Documents'];
  orderCaseDetails = [];
  users = [];
  printLoading: boolean = false;
  dataReady: boolean = false;

  ngOnInit(): void {
    this.subscribeEvent(EventList.caseDetailPrint, (event) => {
      var interval = setInterval(() => {
        if (this.dataReady) {
          clearInterval(interval);
          this.printModalContents(true, event.dialog);
        }
      }, 200);
    });
  }

  ngOnChanges(): void {
    this.dataReady = false;
    this.dataService.getTemplate(this.caseDetails.Template).then(temp=>{
      this.dataService.getUsers().then((res) => {
        this.users = res;

        this.template = temp;
        this.orderCaseDetails = [];
        _.forEach(this.template.Groups,(t)=>{
          var data = {tab:t.Tab, fields:[], subGroups:[]}
            _.forEach(t.Fields, (f)=>{
              if(this.caseDetails.Data[f.Name]){
                var value = this.caseDetails.Data[f.Name];
                if(f.Name == 'CaseOwner'){
                  const owner = this.users.find(u => u.Id == this.caseDetails.Data[f.Name]);
                  if (owner) {
                    const ownerName = `${owner.FirstName} ${owner.LastName}`;
                    value = ownerName;
                  }
                }
                data.fields.push({tab: t.Tab, description: f.Description,value: value})
              }
            if(f.InnerGroup){
              var innerGroup = {title: f.Title,fields:[]};
              _.forEach(f.InnerGroup,(i)=>{
                if(this.caseDetails.Data[i.Name]){
                  innerGroup.fields.push({ description: i.Description,value: this.caseDetails.Data[i.Name]});
                }
              });
              if(innerGroup.fields.length >0){
                data.subGroups.push(innerGroup);
              }
            }
            });
          const existingData = _.findLast(this.orderCaseDetails, d=> d.tab === data.tab);
          if(existingData){
          existingData.fields = _.concat(existingData.fields,data.fields);
          existingData.subGroups = _.concat(existingData.subGroups,data.subGroups);

          } else if(data.fields.length >0 || data.subGroups.length >0) {
              this.orderCaseDetails.push(data);
          }

        });
        this.setFamilyDetails();
        this.dataReady = true;
      });

    });
  }

  setFamilyDetails(){
    const subGroup =  {title:"Family Interviews",fields:[]};

    _.forEach(this.caseDetails.Data, (value, key)=>{
      if(key.includes("FamilyInterview")){
        subGroup.fields.push({"description": this.replaceCamelCase(key), "value": value});
      }});
    if(subGroup.fields.length>0){
      let demographics =  _.findLast(this.orderCaseDetails, d=> d.tab === "Demographics");
      if(!demographics){
        demographics = {tab:"Demographics", fields:[], subGroups:[]};
        this.orderCaseDetails.push(demographics);
      }
      demographics.subGroups.push(subGroup);
    }
  }
  replaceCamelCase(str: string) {
    return str
    .replace(/([A-Z])/g, ' $1')   // insert a space before all caps
    .replace(/^./, function(str){ return str.toUpperCase(); })   // uppercase the first character
  }

  printModalContents(close: boolean = false, dialog: DialogRef = null) {
    this.printLoading = true;
    let data = {
      caseId: this.caseDetails.id,
      caseDetails: this.orderCaseDetails
    };
    this.caseService.printFormDetails(JSON.stringify(data)).then(pdfBlob => {
      const blobUrl = URL.createObjectURL(pdfBlob);
      const newTab = window.open(blobUrl, '_blank');
      newTab.onload = () => {
        newTab.print();
        URL.revokeObjectURL(blobUrl);
      };
      this.printLoading = false;
      if (close) {
        dialog.close();
      }
    }).catch(err => {
      this.printLoading = false;
      if (close) {
        dialog.close();
      }
    });
  }

}
